<template>
	<div class="box-border flex flex-col" :class="['lang_select', !prop.border ? 'no_border' : '']">
		<el-select v-model="languageKey" placeholder="Select" size="large" popper-class="custom_select" :style="{ width: prop.width }" @change="confirmSet">
			<el-option v-for="item in langConfigList" :key="item.value" :label="formatLangName(item.lang)" :value="item.abbreviation">
				<div class="flex items-center justify-between min-w-[200px]">
					<span class="min-w-0 truncate">{{ item.lang }}</span>
					<el-icon v-if="languageKey === item.abbreviation" color="#F92863" size="20px"><CircleCheckFilled /></el-icon>
				</div>
			</el-option>
		</el-select>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import useStore from '@/store'
import { useRouter } from 'vue-router'
const router = useRouter()
const { userStore } = useStore()
const { language, langConfigList } = storeToRefs(userStore)

const prop = defineProps({
	border: {
		type: Boolean,
		default: true
	},
	width: {
		type: String,
		default: '200px'
	}
})
// 多语言选项
const languageKey = ref(language.value)

// 语言名称最大显示长度，超出截断加省略号，避免长名称（如俄语）换行
const MAX_LANG_LENGTH = 14
const formatLangName = (lang: string): string => {
	if (!lang) return ''
	return lang.length > MAX_LANG_LENGTH ? `${lang.slice(0, MAX_LANG_LENGTH)}...` : lang
}

//确认设置语言
const confirmSet = (languageKey: string) => {
	const langItme = langConfigList.value.find((item: any) => item.abbreviation == languageKey)
	userStore.setLanguageStr(langItme ? langItme.lang : 'English（US）')
	userStore.setLangIndex(langItme ? langItme.index : 2)
	userStore.setLanguage(langItme ? langItme.abbreviation : 'en')
	//刷新页面
	router.go(0)
}
</script>

<style lang="scss" scoped>
.lang_select {
	:deep(.el-select__placeholder) {
		font-size: 14px;
	}
	:deep(.el-select__selected-item) {
		font-size: 14px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	:deep(.el-select--large .el-select__wrapper) {
		min-height: 36px;
	}
	:deep(.el-select__wrapper.is-hovering:not(.is-focused)) {
		box-shadow: none;
	}
	:deep(.el-select__wrapper.is-hovering .el-select__selected-item) {
		color: #f92863;
	}
}
.no_border {
	:deep(.el-select__wrapper) {
		box-shadow: none;
	}
}
</style>
